<template>
  <div class="app-shell">
    <div class="app-wrap">
      <aside class="sidebar">
        <div class="brand-block">
          <div class="brand-logo">知</div>
          <div class="brand-name">对话小助手</div>
        </div>
        <div class="side-menu">
          <button
            v-for="item in navItems"
            :key="item.path"
            :class="{ on: activePath === item.path }"
            @click="onSelect(item.path)"
          >
            <i class="menu-icon" :class="item.icon" aria-hidden="true"></i>
            <span class="menu-text">{{ item.label }}</span>
          </button>
        </div>
      </aside>
      <main class="main-pane">
        <div class="topbar">
          <div class="breadcrumb">{{ breadcrumb }}</div>
          <div class="user-area">
            <span>用户：{{ username }}</span>
            <el-button size="mini" class="mz-warning" @click="logout">退出</el-button>
          </div>
        </div>
        <section class="main-content">
          <router-view />
        </section>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isAdmin() {
      if (localStorage.getItem("is_admin") === "1") return true;
      const username = String(localStorage.getItem("username") || "").trim();
      if (username === "吴强") return true;
      const normalizedUsername = username.toLowerCase();
      if (normalizedUsername === "admin@mianzhi.com" || normalizedUsername === "admin") return true;
      try {
        const user = JSON.parse(localStorage.getItem("auth_user") || "{}");
        if (Number(user?.is_admin) === 1 || user?.is_admin === true) return true;
        return String(user?.name || "").trim() === "吴强";
      } catch (e) {
        return false;
      }
    },
    canViewMediaLibrary() {
      if (this.isAdmin) return true;
      const username = String(localStorage.getItem("username") || "").trim();
      if (username === "吴强") return true;
      try {
        const user = JSON.parse(localStorage.getItem("auth_user") || "{}");
        return String(user?.name || "").trim() === "吴强";
      } catch (e) {
        return false;
      }
    },
    canViewLeads() {
      if (this.isAdmin) return true;
      if (this.isLeadOnlyUser) return true;
      const username = String(localStorage.getItem("username") || "").trim();
      if (username === "储昌宏") return true;
      try {
        const user = JSON.parse(localStorage.getItem("auth_user") || "{}");
        return String(user?.name || "").trim() === "储昌宏";
      } catch (e) {
        return false;
      }
    },
    isLeadOnlyUser() {
      if (this.isAdmin) return false;
      const username = String(localStorage.getItem("username") || "").trim();
      if (username === "储昌宏") return true;
      try {
        const user = JSON.parse(localStorage.getItem("auth_user") || "{}");
        return String(user?.name || "").trim() === "储昌宏";
      } catch (e) {
        return false;
      }
    },
    navItems() {
      if (this.isLeadOnlyUser) {
        return [
          { path: "/leads", label: "线索列表", icon: "el-icon-collection-tag" }
        ];
      }
      const items = [
        { path: "/home", label: "首页", icon: "el-icon-s-home" },
        { path: "/personnel", label: "人员管理", icon: "el-icon-user-solid" },
        { path: "/customers", label: "客户列表", icon: "el-icon-s-custom" },
        { path: "/monitor", label: "智能体监控", icon: "el-icon-video-camera" }
      ];
      if (this.isAdmin) {
        items.push({ path: "/departments", label: "部门管理", icon: "el-icon-s-operation" });
      }
      if (this.canViewLeads) {
        items.push({ path: "/leads", label: "线索列表", icon: "el-icon-collection-tag" });
      }
      if (this.canViewMediaLibrary) {
        items.push({ path: "/media-library", label: "图片素材库", icon: "el-icon-picture-outline" });
      }
      if (this.isAdmin) {
        items.push({ path: "/settings", label: "系统设置", icon: "el-icon-setting" });
      }
      return items;
    },
    activePath() {
      if (this.$route.path.startsWith("/personnel/")) return "/personnel";
      if (this.$route.path.startsWith("/customers/")) return "/customers";
      if (this.$route.path.startsWith("/leads/")) return "/leads";
      return this.$route.path;
    },
    username() {
      return localStorage.getItem("username") || "Admin";
    },
    breadcrumb() {
      const map = {
        "/home": "首页 / 统计页面",
        "/personnel": "首页 / 人员管理",
        "/customers": "首页 / 客户列表",
        "/departments": "首页 / 部门管理",
        "/leads": "首页 / 线索列表",
        "/monitor": "首页 / 智能体监控",
        "/media-library": "首页 / 图片素材库",
        "/settings": "首页 / 系统设置"
      };
      if (this.$route.path.startsWith("/personnel/")) return "首页 / 人员管理 / 人员详情";
      if (this.$route.path.startsWith("/customers/")) return "首页 / 客户列表 / 对话详情";
      if (this.$route.path.startsWith("/leads/")) return "首页 / 线索列表";
      return map[this.$route.path] || "首页";
    }
  },
  methods: {
    onSelect(path) {
      if (path !== this.$route.path) this.$router.push(path);
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("is_admin");
      localStorage.removeItem("auth_user");
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.menu-icon {
  font-size: 15px;
  width: 16px;
  text-align: center;
  opacity: 0.95;
}

.menu-text {
  line-height: 1;
}
</style>
